var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHalfBathroom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeWidth: 1.3,
  clipPath: "url(#half_bathroom_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.5 8.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V16a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1zM19.5 14.5H9.75a1.25 1.25 0 1 0 0 2.5H10m0 0h12c.552 0 1.032.457.9.993-.189.766-.646 1.13-1.4 1.507a2.1 2.1 0 0 0-.734.602c-.334.44-.266 1.346-.266 1.898v2.5a1 1 0 0 1-1 1H14c-.552 0-.956-.445-.847-.987q.059-.293.148-.685c.11-.478-.14-.961-.552-1.229C10.573 21.182 10 18.356 10 17Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "half_bathroom_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.5 6.5h20v20h-20z"
})))));
export default SvgHalfBathroom;